import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "./Slice/authSlice";
import passwordSlice from "./Slice/passwordSlice";
import classSlice from "./Slice/classSlice";
import teacherSlice from "./Slice/teacherSlice";
import manageAdminSlice from "./Slice/manageAdminSlice";
import studentSlice from "./Slice/studentSlice";
import browseSlice from "./Slice/browseSlice";
import collectionSlice from "./Slice/collectionSlice";
import faqSlice from "./Slice/faqSlice";
import likesSlice from "./Slice/likesSlice";
import reportSlice from "./Slice/reportSlice";
import notificationSlice from "./Slice/notificationSlice";
import dashboardSlice from "./Slice/dashboardSlice";
import PackSlice from "./Slice/packSlice";
import organisationSlice from "./Slice/organisationSlice";


const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["userData"],
};

const rootReducer = combineReducers({
  authSlice: persistReducer(authPersistConfig, authSlice),
  passwordSlice,
  classSlice,
  teacherSlice,
  studentSlice,
  browseSlice,
  collectionSlice,
  faqSlice,
  likesSlice,
  reportSlice,
  notificationSlice,
  dashboardSlice,
  manageAdminSlice,
  PackSlice,
  organisationSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
